import gql from 'graphql-tag';
import { NOTIFICATION_SETTINGS_FRAGMENT } from '@/graphql/queries/notification-queries';

export const UPDATE_NOTIFICATION_SETTING = gql`
${NOTIFICATION_SETTINGS_FRAGMENT}
mutation updateNotificationSettings($typeId: String!, $emailEnabled: Boolean, $onSiteEnabled: Boolean) {
  updateNotificationSettings(typeId: $typeId, emailEnabled: $emailEnabled, onSiteEnabled: $onSiteEnabled) {
    ...notificationSettingsFragment
    notificationSettings{
      ...notificationSettingsFragment
    }
  }
}
`;

export const MANAGE_SUBSCRIPTION = gql`
mutation manageSubscription($assocId: NexusId!, $assocType: SubscribableType!, $subscribing: Boolean!) {
  manageSubscription(assocId: $assocId, assocType: $assocType, subscribing: $subscribing) {
    assocId
  }
}
`;

export const TURN_OFF_NOTIFICATION = gql`
mutation turnOffNotification($id: NexusId!) {
  turnOffNotification(id: $id) {
    body
    id
    insertedAt
    uri
    viewedAt
    triggeredByUser {
      id
      username
      avatar {
        thumb
      }
    }
  }
}
`;
